import React, { useEffect } from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useUserInvitationsState,
  useUserInvitationsActions
} from './UserInvitationsContext';

import {
  approveUserInvitationRequest,
  denyUserInvitationRequest,
  getUserInvitationRequests,
} from './restApi';

import styles from './UserInvitations.module.scss';

const UserInvitationRequestsTable = () => {
  const userInvitationsState = useUserInvitationsState();
  const { onResponse, onError } = useUserInvitationsActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    getUserInvitationRequests({ onResponse, onError });
  }, []);

  return userInvitationsState?.userInvitationRequests?.length ? (
    <table className={styles.table}>
      <thead>
        <tr className={styles.tr}>
          <th className={styles.th}>Name</th>
          <th className={styles.th}>Email</th>
          <th className={styles.th}>Status</th>
          <th className={styles.th}>Created At</th>
        </tr>
      </thead>
      <tbody>
        {userInvitationsState?.userInvitationRequests?.map(request => {
          return (
            <tr key={request.id} className={styles.tr}>
              <td className={styles.td}>{request.firstName} {request.lastName}</td>
              <td className={styles.td}>{request.email}</td>
              <td className={styles.td}>{request.aasmState}</td>
              <td className={styles.td}>{request.createdAt}</td>
              <td className={styles.td}>
                <Button
                  variant="primary"
                  onClick={() => {
                    approveUserInvitationRequest(({
                      userInvitationRequest: request,
                      onResponse,
                      onError,
                      body: {
                        authenticity_token: authenticityToken,
                      },
                    }));
                  }}
                >
                  Approve
                </Button>
              </td>
              <td className={styles.td}>
                <Button
                  variant="destructive"
                  onClick={() => {
                    denyUserInvitationRequest(({
                      userInvitationRequest: request,
                      onResponse,
                      onError,
                      body: {
                        authenticity_token: authenticityToken,
                      },
                    }));
                  }}
                >
                  Deny
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <p className={styles.noContentMessage}>No user invitation requests.</p>
  );
};

export default UserInvitationRequestsTable;
